import { render, staticRenderFns } from "./SearchDialogBottomBar.vue?vue&type=template&id=2bef8d9a&scoped=true&"
import script from "./SearchDialogBottomBar.vue?vue&type=script&lang=js&"
export * from "./SearchDialogBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchDialogBottomBar.vue?vue&type=style&index=0&id=2bef8d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef8d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VSpacer})
